import React, { useState, useRef } from 'react';

const Calculator17 = () => {
    const [basicSalary, setBasicSalary] = useState('');
    // const [dra, setDra] = useState(null);
    const [adhoc, setAdhoc] = useState(null);
    const [total, setTotal] = useState(null);
    const [error, setError] = useState('');

    const modalRef = useRef();

    const calculateSalaryIncrease = () => {
        const salary = parseFloat(basicSalary);
        if (isNaN(salary) || salary <= 0) {
            setError('Please enter a valid basic salary.');
            // setDra(null);
            setAdhoc(null);
            setTotal(null);
            return;
        }

        // const draCalc = salary * 0.3;
        const adhocCalc = salary * 0.1;
        const totalCalc = adhocCalc;

        // setDra(draCalc.toFixed(2));
        setAdhoc(adhocCalc.toFixed(2));
        setTotal(totalCalc.toFixed(2));
        setError('');

        // Show the Bootstrap modal
        const modal = new window.bootstrap.Modal(modalRef.current);
        modal.show();
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow animate__animated animate__fadeIn">
                        <div className="card-body">
                            <h2 className="text-center text-primary mb-4">17 and Above Salary Increase Calculator</h2>

                            <div className="mb-3">
                                <h5 htmlFor="basicSalary" className="form-label fw-semibold">Basic Pay:</h5>
                                <input
                                    type="number"
                                    id="basicSalary"
                                    className="form-control"
                                    value={basicSalary}
                                    onChange={(e) => setBasicSalary(e.target.value)}
                                    placeholder="Enter your basic pay"
                                />
                            </div>

                            <div className="d-grid gap-2">
                                <button className="btn btn-primary" onClick={calculateSalaryIncrease}>
                                    Calculate
                                </button>
                            </div>

                            {error && (
                                <div className="alert alert-danger mt-3" role="alert">
                                    {error}
                                </div>
                            )}

                            <footer className="text-center mt-4 text-muted">
                                Muhammad Uzair Ihsan
                            </footer>
                            <div className="text-center mt-2 text-danger Danger" style={{ fontSize: "0.9rem" }}>
                                <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                This Calculator is not official
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bootstrap Modal */}
            <div
                className="modal fade"
                tabIndex="-1"
                ref={modalRef}
                aria-labelledby="salaryModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title" id="salaryModalLabel">Salary Increase Result</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            {/* <p><i className="fas fa-percentage text-danger"></i> <strong> DRA (30%):</strong> <span className="text-danger">{dra}</span></p> */}
                            <p><i className="fas fa-coins text-warning"></i> <strong> Adhoc Relief (10%):</strong> <span className="text-warning">{adhoc}</span></p>
                            <hr />
                            <p><strong>Total Increase:</strong> <span className="text-success">{total}</span></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Calculator17;

